module.exports = __webpack_public_path__ + "static/media/feather-sprite.0ed672ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Icon/feather-sprite.svg
// module id = 156
// module chunks = 2